<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("EditFavorite") }}</span>

        <div class="right">
          <a v-on:click="$router.go(-1)"> {{ $t("Done") }}</a>
        </div>
      </div>
    </div>
    <div class="topfix">
      <div class="container-center lg">
        <div class="tophead text-center">
          <div class="col-xs-3 active" v-if="market.indexOf('ALL') > -1">
            <p class="pointer">ALL<i class="m-l-xs fad fa-dollar-sign"></i></p>
          </div>
          <div class="col-xs-3" v-else v-on:click="market = 'ALL'">
            <p class="pointer">ALL<i class="m-l-xs fad fa-dollar-sign"></i></p>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-center lg animated fadeIn">
      <div class="market" v-if="getMarket">
        <div class="divTable">
          <div class="divTableHeading">
            <div class="divTableRow">
              <div class="divTableHead width-pair">
                {{ $t("Name") }} / {{ $t("Vol") }}
              </div>
              <div class="divTableHead width-price">
                {{ $t("LastPrice") }}
              </div>
              <div class="divTableHead text-center width-change">
                {{ $t("Star") }}
              </div>
            </div>
          </div>
          <div class="divTableBody" v-for="m in getMarket" v-bind:key="m.pair">
            <div
              v-on:click="addFavorites(m.pair)"
              tag="div"
              class="divTableRow marketList"
            >
              <div class="divTableCell width-pair">
                <h4>
                  {{ m.primary }} /
                  <span class="font-bold c-white"> {{ m.secondary }}</span>
                </h4>
                <span class="fav"
                  >{{ $t("Vol") }} ${{ fixed(m.amount_24hrs) }}</span
                >
              </div>

              <div class="divTableCell width-price">
                <h4 class="font-bold c-white">
                  {{ digit(m.last_price, m.rate_digi) }}
                </h4>
                {{ $t("avg") }} {{ digit(m.average, m.rate_digi) }}
              </div>

              <div class="divTableCell width-change text-center">
                <a>
                  <span class="text-accent" v-if="starMarket[m.pair]">
                    <span class="fad fa-star"></span>
                  </span>
                  <span class="text-muted" v-else>
                    <span class="far fa-star"></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      market: "ALL",
      starMarket: JSON.parse(localStorage.getItem("StarMarket"))
    };
  },
  computed: mapGetters(["getMarket", "getPairing"]),
  methods: {
    ...mapActions(["fetchMarket"]),
    addFavorites(pair) {
      var oldItems = JSON.parse(localStorage.getItem("StarMarket"));

      oldItems[pair] = !oldItems[pair];

      this.starMarket = oldItems;
      localStorage.setItem("StarMarket", JSON.stringify(oldItems));
    },
    fixed(a) {
      return (a.toFixed(0) / 1).toLocaleString();
    },
    digit(a, digi) {
      if (a) {
        return a.toLocaleString(undefined, {
          minimumFractionDigits: digi
        });
      }
    }
  },
  created() {
    this.fetchMarket();
    this.starMarket = JSON.parse(localStorage.getItem("StarMarket"));
  }
};
</script>

<style scoped>
.btn {
  font-size: 16px;
}
.btn:hover {
  color: #ffffff;
}
.text-connect {
  color: #97c378;
}
.active p {
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
}
.container-center {
  margin-top: 0px;
  padding: 0px;
}
.market {
  display: block;
  top: 71px;
  padding: 0 0 73px 0;
  position: relative;
  min-height: 386px;
  width: 100%;
}
.market .divTableCell {
  border-bottom: 1px solid #434039;
  vertical-align: middle;
  padding: 5px;
}
.divTableHeading .divTableRow {
  background-color: #444953;
}
.divTableCell,
.divTableHead {
  width: 33.33333%;
  border: 0px solid #3d404c;
}

.divTableBody .divTableRow:hover {
  cursor: pointer;
}
.width-pair {
  width: 40%;
}
.width-price {
  width: 35%;
}
.width-change {
  width: 25%;
}
</style>
